






































































































































































import AnalyticsDateRangeSelectorDialog from "@/components/analytics/AnalyticsDateRangeSelectorDialog.vue";
import BarChartCard from "@/components/analytics/BarChartCard.vue";
import PieChartCard from "@/components/analytics/PieChartCard.vue";
import TimeSeriesLineChartCard from "@/components/analytics/TimeSeriesLineChartCard.vue";
import FleetManagerTreeDialog from "@/components/fleet/FleetManagerTreeDialog.vue";
import MHeader, { IAction } from "@/components/utility/mmmint/MHeader.vue";
import LayoutReportWithBanner from "@/layouts/LayoutReportWithBanner.vue";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { IBreadcrumb } from "@/lib/interfaces/utility/breadcrumb-interface";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { DocumentDirectionEnum } from "@/models/invoice.entity";
import { MrfiktivBaseChartItemViewmodelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { CompanyAffiliateEnum } from "@/store/enum/company-affiliate.enum";
import { AnalyticsFleetModule } from "@/store/modules/fleet/analytics-fleet.store";
import { FleetManagerModule } from "@/store/modules/fleet/manager-fleet.store";
import { UserModule } from "@/store/modules/me-user.store";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Vue, Watch } from "vue-property-decorator";
import FleetCostCenterSelectorDialog from "@/components/fleet/FleetCostCenterDialog.vue";
import { IPageFilterElement } from "@/models/page-filter-element.entity";

type DataHandlerItem = {
  isLoading: boolean;
  getData: (fleetIds: string[], filters?: IPageFilterElement[]) => Promise<void>;
};

type DataHandler = Record<string, DataHandlerItem>;

@Component({
  components: {
    LayoutReportWithBanner,
    PieChartCard,
    BarChartCard,
    AnalyticsDateRangeSelectorDialog,
    TimeSeriesLineChartCard,
    FleetManagerTreeDialog,
    FleetCostCenterSelectorDialog,
    MHeader
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class FleetAnalyticsView extends Vue {
  DocumentDirectionEnum = DocumentDirectionEnum;

  isLoading = false;
  selectedId: string | null = null;
  tab = 0;
  isTreeDialogOpen = false;
  tempSelected: string[] = [];
  openNodes: string[] = [];
  selectedCostCenters: Array<{ id: string; name: string }> = [];

  @Watch("parentFleetId")
  async onParentFleetChanged(newFleetId: string, oldFleetId: string) {
    if (newFleetId && newFleetId !== oldFleetId) {
      await FleetManagerModule.setSelectedFleetId({ fleetId: newFleetId, partnerId: this.partnerId });
      this.load();
    }
  }

  @Watch("tab")
  onTabChanged() {
    if (this.selectedCostCenters.length > 0) {
      this.applyFilters();
    }
  }

  dataHandler: DataHandler = {
    coverageTypeCount: {
      getData: async (fleetIds: string[], filters?: IPageFilterElement[]) => {
        const ids = this.includeFleetIds(fleetIds);
        await AnalyticsFleetModule.getCoverageTypeData({
          partnerId: this.partnerId,
          fleetId: this.parentFleetId,
          ids,
          filters
        });
      },
      isLoading: false
    },
    damageTypeCount: {
      getData: async (fleetIds: string[], filters?: IPageFilterElement[]) => {
        const ids = this.includeFleetIds(fleetIds);
        await AnalyticsFleetModule.getDamageTypeData({
          partnerId: this.partnerId,
          fleetId: this.parentFleetId,
          ids,
          filters
        });
      },
      isLoading: false
    },
    tripTypeCount: {
      getData: async (fleetIds: string[], filters?: IPageFilterElement[]) => {
        const ids = this.includeFleetIds(fleetIds);
        await AnalyticsFleetModule.getTripTypeData({
          partnerId: this.partnerId,
          fleetId: this.parentFleetId,
          ids,
          filters
        });
      },
      isLoading: false
    },
    statusValueDistribution: {
      getData: async (fleetIds: string[], filters?: IPageFilterElement[]) => {
        const ids = this.includeFleetIds(fleetIds);
        await AnalyticsFleetModule.getStatusValueDistribution({
          partnerId: this.partnerId,
          fleetId: this.parentFleetId,
          ids,
          filters
        });
      },
      isLoading: false
    },
    progressStatusDistribution: {
      getData: async (fleetIds: string[], filters?: IPageFilterElement[]) => {
        const ids = this.includeFleetIds(fleetIds);
        await AnalyticsFleetModule.getProgressStatusDistribution({
          partnerId: this.partnerId,
          fleetId: this.parentFleetId,
          ids,
          filters
        });
      },
      isLoading: false
    },
    workshopCompanyDistribution: {
      getData: async (fleetIds: string[], filters?: IPageFilterElement[]) => {
        const ids = this.includeFleetIds(fleetIds);
        await AnalyticsFleetModule.getWorkshopCompanyDistribution({
          partnerId: this.partnerId,
          fleetId: this.parentFleetId,
          ids,
          filters
        });
      },
      isLoading: false
    },
    weekdayDistribution: {
      getData: async (fleetIds: string[], filters?: IPageFilterElement[]) => {
        const ids = this.includeFleetIds(fleetIds);
        await AnalyticsFleetModule.getWeekdayAnalysis({
          partnerId: this.partnerId,
          fleetId: this.parentFleetId,
          ids,
          filters
        });
      },
      isLoading: false
    },
    coverageSubtotalDeductible: {
      getData: async (fleetIds: string[], filters?: IPageFilterElement[]) => {
        const ids = this.includeFleetIds(fleetIds);
        await AnalyticsFleetModule.getCoverageSubtotalDeductible({
          partnerId: this.partnerId,
          fleetId: this.parentFleetId,
          ids,
          filters
        });
      },
      isLoading: false
    },
    coverageTypeSubtotal: {
      getData: async (fleetIds: string[], filters?: IPageFilterElement[]) => {
        const ids = this.includeFleetIds(fleetIds);
        await AnalyticsFleetModule.getCoverageTypeSubtotalData({
          partnerId: this.partnerId,
          fleetId: this.parentFleetId,
          ids,
          filters
        });
      },
      isLoading: false
    },
    damageTypeSubtotal: {
      getData: async (fleetIds: string[], filters?: IPageFilterElement[]) => {
        const ids = this.includeFleetIds(fleetIds);
        await AnalyticsFleetModule.getDamageTypeSubtotalData({
          partnerId: this.partnerId,
          fleetId: this.parentFleetId,
          ids,
          filters
        });
      },
      isLoading: false
    },
    topCreditor: {
      getData: async (fleetIds: string[], filters?: IPageFilterElement[]) => {
        const ids = this.includeFleetIds(fleetIds);
        await AnalyticsFleetModule.getTopCreditorData({
          partnerId: this.partnerId,
          fleetId: this.parentFleetId,
          ids,
          filters
        });
      },
      isLoading: false
    },
    reportTrendAnalysis: {
      getData: async (fleetIds: string[], filters?: IPageFilterElement[]) => {
        const ids = this.includeFleetIds(fleetIds);
        await AnalyticsFleetModule.getTrendAnalysisDataPerPartnerFleetId({
          partnerId: this.partnerId,
          fleetId: this.parentFleetId,
          ids,
          filters
        });
      },
      isLoading: false
    },
    topVehicle: {
      getData: async (fleetIds: string[], filters?: IPageFilterElement[]) => {
        const ids = this.includeFleetIds(fleetIds);
        await AnalyticsFleetModule.getTopVehicleData({
          partnerId: this.partnerId,
          fleetId: this.parentFleetId,
          ids,
          filters
        });
      },
      isLoading: false
    }
  };

  get fleetIdList() {
    return UserModule.fleetPermission?.filter(p => p.partnerId === this.partnerId).map(p => p.fleetId) ?? [];
  }

  get uniqueFleetIds() {
    const fleetIds = new Set();

    this.fleetIdList.forEach(i => fleetIds.add(i));

    return fleetIds.values();
  }

  get uniqueFleetCount() {
    return Array.from(this.uniqueFleetIds).length;
  }

  get title() {
    return `${this.$t("report.thgOverview.title")}  ${UserModule.user?.firstName} ${UserModule.user?.lastName} ☀️`;
  }
  get description() {
    return this.$t("report.thgOverview.description");
  }

  get chips(): IAction[] {
    const chips: IAction[] = [];

    if (this.uniqueFleetCount > 1) {
      chips.push({
        text: `${this.uniqueFleetCount} ${this.$t("views.fleet.FleetHomeView.fleetTrees")}`,
        key: "fleet-tree",
        icon: "mdi-family-tree"
      });
    }

    chips.push(
      ...[
        {
          text: this.$t("views.fleet.FleetHomeView.selectedFleets", { n: this.selectedFleetIds.length }).toString(),
          key: "fleet",
          icon: "mdi-car-multiple",
          exec: () => ((this.$refs.dialog as unknown) as IDialog)?.open()
        }
      ]
    );

    if (this.selectedCostCenters.length > 0) {
      chips.push({
        text: this.selectedCostCenters[0].name,
        key: "costCenter",
        icon: "mdi-currency-eur",
        exec: () => this.openCostCenterDialog()
      });
    }

    return chips;
  }

  get breadCrumbs(): IBreadcrumb[] {
    const breadCrumbs: IBreadcrumb[] = [];

    breadCrumbs.push({
      text: this.$t("nav.FleetTableView.description"),
      disabled: true,
      exact: true,
      to: {
        name: "FleetAnalyticsView",
        params: {}
      }
    });

    return breadCrumbs;
  }

  get actions(): IAction[] {
    const actions: IAction[] = [];
    if (this.uniqueFleetCount > 1) {
      actions.push({
        text: this.$t("views.report.fleet.FleetAnalyticsView.selectionDialog.openFleetTree").toString(),
        key: "fleet",
        exec: () => ((this.$refs.dialog as unknown) as IDialog)?.open()
      });
    }

    actions.push({
      text: this.$t("views.report.fleet.FleetAnalyticsView.selectCostCenter").toString(),
      key: "costCenter",
      exec: () => this.openCostCenterDialog()
    });

    return actions;
  }

  get dates() {
    return AnalyticsFleetModule.dateRange;
  }

  get partnerId() {
    return ReportModule.partner.id;
  }

  get fleetId() {
    return FleetManagerModule.selectedFleetId;
  }

  get damageTypeSubtotalData(): MrfiktivBaseChartItemViewmodelGen[] {
    return AnalyticsFleetModule.damageTypeSubtotalOutboundData.map(c => ({
      name: this.$t(`enums.DamageTypeEnum.${c.name}`).toString(),
      value: c.value ?? undefined
    }));
  }

  get coverageTypeSubtotalData(): MrfiktivBaseChartItemViewmodelGen[] {
    return AnalyticsFleetModule.coverageTypeSubtotalOutboundData.map(c => ({
      name: this.$t(`enums.CoverageTypeEnum.${c.name}`).toString(),
      value: c.value ?? undefined
    }));
  }

  get coverageSubtotalDeductibleData() {
    return AnalyticsFleetModule.coverageSubtotalDeductibleData.map(c => ({
      coverageType: c.coverageType,
      data: [
        {
          name: this.$t("views.report.fleet.FleetAnalyticsView.cost.total").toString(),
          value: c.subTotal
        },
        {
          name: this.$t("views.report.fleet.FleetAnalyticsView.cost.deductible").toString(),
          value: c.deductible
        }
      ]
    }));
  }

  get damageTypeCountData(): MrfiktivBaseChartItemViewmodelGen[] {
    return AnalyticsFleetModule.damageTypeData.map(c => ({
      name: this.$t(`enums.DamageTypeEnum.${c.name}`).toString(),
      value: c.value ?? undefined
    }));
  }

  get coverageTypeCountData(): MrfiktivBaseChartItemViewmodelGen[] {
    return AnalyticsFleetModule.coverageTypeData.map(c => ({
      name: this.$t(`enums.CoverageTypeEnum.${c.name}`).toString(),
      value: c.value ?? undefined
    }));
  }

  get tripTypeCountData(): MrfiktivBaseChartItemViewmodelGen[] {
    return AnalyticsFleetModule.tripTypeData.map(c => ({
      name: this.$t(`enums.TripTypeEnum.${c.name}`).toString(),
      value: c.value ?? undefined
    }));
  }

  get privateTripKpiGroup() {
    const total = AnalyticsFleetModule.tripTypeData.reduce((sum, item) => sum + (item.value || 0), 0);
    const privateTrip = AnalyticsFleetModule.tripTypeData.find(c => c.name === "PRIVATE")?.value || 0;
    const percentage = total > 0 ? (privateTrip / total) * 100 : 0;
    return [
      {
        icon: "mdi-percent",
        value: Math.round(percentage * 10) / 10,
        name: this.$t("views.report.fleet.FleetAnalyticsView.privateTripCount")
      }
    ];
  }

  get statusDistributionData() {
    if (this.hasStatusValueDistributionData) {
      return AnalyticsFleetModule.statusValueDistributionData.map(c => ({
        name: c.name,
        value: c.value
      }));
    }
    return AnalyticsFleetModule.progressStatusDistributionData.map(c => ({
      name: this.$t(`partner.common.reportProgressStatus.${c.name}`).toString(),
      value: c.value
    }));
  }

  get statusDistributionKpiGroup() {
    return [
      {
        icon: "mdi-circle-outline",
        value: AnalyticsFleetModule.progressStatusDistributionData
          .filter(c => c.name === "new" || c.name === "inProgress")
          .reduce((sum, c) => sum + (c.value ?? 0), 0),
        name: this.$t("enums.InvoiceStatusEnum.open")
      },
      {
        icon: "mdi-check-circle-outline",
        value: AnalyticsFleetModule.progressStatusDistributionData.find(c => c.name === "finished")?.value || 0,
        name: this.$t("enums.AnonymizationStatusEnum.Completed")
      }
    ];
  }

  get workshopDistributionKpiGroup() {
    const data = this.workshopCompanyDistributionData;
    const affiliate = data.find(f => f.name === this.$t("enums.CompanyAffiliateEnum.AFFILIATE"));
    const total = data.reduce((sum, c) => sum + c.value, 0);
    const percentage = total > 0 ? ((affiliate?.value ?? 0) / total) * 100 : 0;

    return [
      {
        icon: "mdi-percent",
        value: Number(percentage.toFixed(2)),
        name: this.$t("enums.CompanyAffiliateEnum.AFFILIATE")
      }
    ];
  }

  get workshopCompanyDistributionData() {
    const data = AnalyticsFleetModule.workshopCompanyDistributionData;

    if (!data || data.length === 0) {
      return [];
    }

    const affiliate = data.find(c => c.name === CompanyAffiliateEnum.AFFILIATE)?.value ?? 0;
    const nonAffiliate = data
      .filter(c => c.name !== CompanyAffiliateEnum.AFFILIATE)
      .reduce((sum, c) => sum + c.value, 0);

    const result = [
      {
        name: this.$t("enums.CompanyAffiliateEnum.AFFILIATE").toString(),
        value: affiliate
      },
      {
        name: this.$t("enums.CompanyAffiliateEnum.NON_AFFILIATE").toString(),
        value: nonAffiliate
      }
    ];

    return result;
  }

  get weekdayDistributionData() {
    return AnalyticsFleetModule.weekdayDistributionData;
  }

  get topCreditorData() {
    return AnalyticsFleetModule.topCreditorData;
  }

  get topVehicleData() {
    return AnalyticsFleetModule.topVehicleData;
  }

  get reportTrendData() {
    const trendData = [
      {
        name: this.$t("views.report.fleet.FleetAnalyticsView.oneDayTrend"),
        type: "line",
        symbol: "none",
        data: AnalyticsFleetModule.trendAnalysisData.data?.dayTrend
      },
      {
        name: this.$t("views.report.fleet.FleetAnalyticsView.sevenDayTrend"),
        type: "line",
        symbol: "none",
        data: AnalyticsFleetModule.trendAnalysisData.data?.sevenDayTend
      },
      {
        name: this.$t("views.report.fleet.FleetAnalyticsView.thirtyDayTrend"),
        type: "line",
        symbol: "none",
        data: AnalyticsFleetModule.trendAnalysisData.data?.thirtyDayTrend
      }
    ];

    return trendData;
  }

  get hasStatusValueDistributionData(): boolean {
    return (
      AnalyticsFleetModule.statusValueDistributionData && AnalyticsFleetModule.statusValueDistributionData.length > 0
    );
  }

  get selectedFleetIds() {
    return FleetManagerModule.selectedFleetIds;
  }

  get fleetTree() {
    return FleetManagerModule.fleetTree;
  }

  get parentFleetId() {
    return FleetManagerModule.selectedFleetId;
  }

  get i18n() {
    return this.$t("views.report.fleet.FleetVehicleView");
  }

  private includeFleetIds(fleetIds: string[]): string[] {
    if (!this.parentFleetId) {
      throw new Error("Select fleet");
    }

    return fleetIds.length === 0 ? [this.parentFleetId] : fleetIds;
  }

  getCurrentKeyType(): "costCenter" | "report.costCenter" {
    return this.tab === 0 ? "costCenter" : "report.costCenter";
  }

  async openCostCenterDialog() {
    const currentId = this.selectedCostCenters[0]?.id || "";
    (this.$refs.costCenterDialog as any)?.open?.([currentId]);
  }

  private updateFiltersFromCostCenter() {
    const keyType = this.getCurrentKeyType();
    const selectedId = this.selectedCostCenters[0]?.id;

    AnalyticsFleetModule.setCostCenterFiltersFromIds({
      ids: selectedId ? [selectedId] : [],
      keyType
    });
  }

  onCostCenterSelected(costCenters: Array<{ id: string; name: string }>) {
    this.selectedCostCenters = costCenters.map(c => ({
      id: c.id,
      name: c.name
    }));

    this.updateFiltersFromCostCenter();
    this.load();
  }

  applyFilters() {
    this.updateFiltersFromCostCenter();
    this.load();
  }

  async mounted() {
    const fleetId = FleetManagerModule.selectedFleetId;

    if (!fleetId) {
      return;
    }

    await this.load();
  }

  async load() {
    const keys = Object.keys(this.dataHandler);

    await Promise.all(
      keys.map(async key => {
        this.dataHandler[key].isLoading = true;

        try {
          await this.dataHandler[key].getData(FleetManagerModule.selectedFleetIds, AnalyticsFleetModule.filters);
        } catch (error) {
          handleError(error);
        } finally {
          this.dataHandler[key].isLoading = false;
        }
      })
    );
  }

  async getData(fleetIds: string[]) {
    const keys = Object.keys(this.dataHandler);
    await Promise.all(
      keys.map(async key => {
        this.dataHandler[key].isLoading = true;

        try {
          await this.dataHandler[key].getData([...fleetIds]);
        } catch (error) {
          this.$log.error(error);
        } finally {
          this.dataHandler[key].isLoading = false;
        }
      })
    );
  }

  setDateRange(dateRange: string[]) {
    AnalyticsFleetModule.setDateRange(dateRange);

    this.load();
  }
}
